<div class="result-container">
  <div class="d-flex justify-content-between">
    <strong class="result-container__title">
      <fstr-icon [ariaHidden]="true" class="icon-secondary" [anchor]="icon()"></fstr-icon>
      {{ title() }}
    </strong>
    <span class="text-white">{{ searchResults().length }} Resultaten</span>
  </div>
  @if (!loading()) {
    <ul class="result-list">
      @for (item of localSearchResults; track item) {
          @let result = asAny(item);
        <li class="result-list__item">
            @if (result['routerLink'] || !result['url']) {
            <a
              (click)="chosen.emit(true)"
              [routerLink]="result['routerLink'] || ['/', 'stofwisselingsziekten', result['id'], result['name'] | urlRewrite]"
              class="result-list__item__link"
            >
              <h1 class="result-list__item__title h6 mb-0">
                  {{ result['title'] || result['name'] }}
                <span class="font-weight-semi text-secondary">
                  {{
                    result['contentType'] ||
                    result['category']?.name ||
                    (result['publishDate'] | date: 'MMM YYYY') ||
                      ''
                  }}
                </span>
              </h1>
              <div class="button button-icon button--xs button-icon--secondary">
                <fstr-icon [ariaHidden]="true" anchor="icon-arrow-right"></fstr-icon>
              </div>
            </a>
          }
          @if (!result['routerLink'] && result['url']) {
              <a [href]="externalUrl() + result['url']" class="result-list__item__link">
              <h1 class="result-list__item__title h6 mb-0">
                  {{ result['title'] || result['name'] }}
                <span class="font-weight-semi text-secondary">
                  {{
                    result['contentType'] ||
                    result['extendedData']?.theme?.title ||
                    (result['publishDate'] | date: 'MMM yyyy') ||
                      ''
                  }}
                </span>
              </h1>
              <div class="button button-icon button--xs button-icon--secondary">
                <fstr-icon [ariaHidden]="true" anchor="icon-arrow-right"></fstr-icon>
              </div>
            </a>
          }
        </li>
      }
      @if (!searchResults().length && !loading()) {
        <li class="result-list__item is--empty">
          <div class="result-list__item__link">
            {{ 'zoek-categorie-niet-gevonden' | fromDictionary }}
          </div>
        </li>
      }
    </ul>
  }
  @if (loading()) {
    <ul class="result-list">
      <li class="result-list__item is--loading">
        <div class="result-list__item__link d-flex justify-content-start">
          <fstr-icon [ariaHidden]="true" class="mr-3 icon-rotating" anchor="icon-loading"></fstr-icon>
          <span>Zoekresultaten zijn aan het laden...</span>
        </div>
      </li>
    </ul>
  }
  @if (showLoadMore) {
    <div class="result-list__load-more text-center mt-3">
      <button (click)="loadMore()" class="button button-outline button-outline--light">
        <span>Laad meer</span>
      </button>
    </div>
  }
</div>
